import { useIntl } from 'react-intl';
import exitWidget from '@onramp/utils/exitWidget';
import { genericMessages } from '@onramp/utils/genericMessages';
import { isMobileExperience } from '@onramp/utils/postMessage';
import { GenericErrorScreenV2 } from '@onramp/v2/client/components/errors/GenericErrorScreenV2';

export default function Error() {
  const { formatMessage } = useIntl();

  // Passing this prevents showing a try again button in mobile
  const handleBack = isMobileExperience() ? exitWidget : undefined;

  return (
    <GenericErrorScreenV2
      title={formatMessage(genericMessages.somethingWentWrong)}
      onBack={handleBack}
    />
  );
}
